import { ComponentProps, Dispatch, SetStateAction } from 'react';

import {
  Assets,
  Button,
  ButtonTextOrIcon,
  Checkbox,
  Container,
  Flex,
  ForaDatePicker,
  SpeechBubble,
  Text,
} from '@foradevelopment/fora-ui';
import { numberToText } from '@fora-monorepo/webapp-i18n';

import { useTypedTranslation } from '../../i18n/i18n';

type TerminateEmploymentFormProps = {
  terminateEmployment: boolean;
  setTerminateEmployment: Dispatch<SetStateAction<boolean>>;
  employmentEndDateInputProps: ComponentProps<typeof ForaDatePicker>;
  submitTerminateEmployment: () => void;
  submitTerminateEmploymentLoading: boolean;
  initiallyTerminated: boolean;
  payMonthMargin: number;
};
export const TerminateEmploymentForm = ({
  terminateEmployment,
  setTerminateEmployment,
  employmentEndDateInputProps,
  submitTerminateEmployment,
  submitTerminateEmploymentLoading,
  initiallyTerminated,
  payMonthMargin,
}: TerminateEmploymentFormProps) => {
  const { t, i18n } = useTypedTranslation();
  return (
    <Container>
      <Checkbox
        onChange={() => setTerminateEmployment(!terminateEmployment)}
        id="terminate-employment-checkbox"
        checked={terminateEmployment}
        disabled={initiallyTerminated}
      >
        <Text size="medium">{t('panel.terminateEmployment.terminateEmploymentText')}</Text>
      </Checkbox>
      <Text color="black70">
        {t(
          initiallyTerminated
            ? 'panel.terminateEmployment.checkBoxDescriptionInitiallyTerminated'
            : 'panel.terminateEmployment.checkBoxDescription'
        )}
      </Text>
      {terminateEmployment && (
        <SpeechBubble marginTop={20}>
          <Text marginBottom={20}>
            {t('panel.terminateEmployment.speechBubbleDescription', {
              payMonthMarginText: numberToText(payMonthMargin, i18n.language),
            })}
          </Text>
          <Flex columnGap={30} rowGap={40} alignItems="flex-start" flexWrap="wrap">
            <ForaDatePicker width="100%" label={t('common.endDate')} {...employmentEndDateInputProps} />
            <Button
              onClick={submitTerminateEmployment}
              variant={initiallyTerminated ? 'primary' : 'burgundy'}
              type="button"
              resetFlexProps
              disabled={submitTerminateEmploymentLoading}
            >
              <ButtonTextOrIcon
                icon={<Assets.Spinner color="white" width={20} center={false} />}
                textColor="white"
                isLoading={submitTerminateEmploymentLoading}
              >
                {t(
                  initiallyTerminated
                    ? 'panel.terminateEmployment.changeEmploymentEndDate'
                    : 'panel.terminateEmployment.terminateEmploymentText'
                )}
              </ButtonTextOrIcon>
            </Button>
          </Flex>
        </SpeechBubble>
      )}
    </Container>
  );
};
